import { combineReducers } from 'redux';

import conversionToolColumnsReducer from './conversionToolColumns/conversionToolColumns.reducer';
import conversionToolMappingEditReducer from './conversionToolMappingEdit/conversionToolMappingEdit.reducer';
import conversionToolMappingsReducer from './conversionToolMappings/conversionToolMappings.reducer';
import createMappingReducer from './createMapping/createMapping.reducer';
import postConversionReducer from './postConversion/postConversion.reducer';

const conversionTool = combineReducers({
  postConversion: postConversionReducer,
  conversionToolColumns: conversionToolColumnsReducer,
  mappings: conversionToolMappingsReducer,
  createMapping: createMappingReducer,
  conversionToolMappingEdit: conversionToolMappingEditReducer,
});

export default conversionTool;
